import { apiService } from '../../shared/services/apiService';
import { ChallengeCheckoutInfo, CheckoutInfo } from '../interfaces/checkoutInfo';
import { PaymentInfo } from '../interfaces/paymentResult';

type CreateFreeChallengeSubscriptionResponse = {
  challengeParticipantId: number;
};

export const checkoutService = {
  async createSubscription(entityId: number, email: string, subscriptionSetupId: number) {
    const params = { entityId, email, subscriptionSetupId };

    const response = await apiService.post<CheckoutInfo>(
      '/api/sign-up/customer/subscribe',
      params,
    );

    return response.data;
  },

  async createScanIqSubscription(entityId: number, subscriptionSetupId: number) {
    const params = { entityId, subscriptionSetupId };

    const response = await apiService.post<CheckoutInfo>(
      '/api/scan-iq/customer/subscribe',
      params,
    );

    return response.data;
  },

  async createNonPaidSubscription(
    entityId: number,
    email: string,
    subscriptionSetupId: number,
  ) {
    const params = { entityId, email, subscriptionSetupId };

    const response = await apiService.post<PaymentInfo>(
      '/api/sign-up/customer/non-paid-subscribe',
      params,
    );

    return response.data;
  },

  async createFreeScanIqSubscription(entityId: number, subscriptionSetupId: number) {
    const params = { entityId, subscriptionSetupId };

    const response = await apiService.post<PaymentInfo>(
      '/api/scan-iq/customer/free-subscribe',
      params,
    );

    return response.data;
  },

  async subscribeToChallenge(participantId: number): Promise<ChallengeCheckoutInfo> {
    const response = await apiService.post<ChallengeCheckoutInfo>(
      `/api/challenge/participant/${participantId}/subscribe`,
    );

    return response.data;
  },

  async createFreeChallengeSubscription(
    participantId: number,
  ): Promise<CreateFreeChallengeSubscriptionResponse> {
    const response = await apiService.post<CreateFreeChallengeSubscriptionResponse>(
      `/api/challenge/participant/${participantId}/free-subscribe`,
    );

    return response.data;
  },
};
